/**
 *
 * en-us
 *
 * English locale labels
 */

export const Strings = {
  ADD_FROM_RECIPIENT_LIST: "Add From Recipient List",
  SWITCH_ACCOUNT: "Switch account",
  CVV_ERROR_MSG: "Enter full cvv",
  CARD_ERROR_MSG: "Invalid Card Number",
  EXPIRY_DATE_ERROR_MSG: "Invalid Expiry Date",
  ACCOMPANYING_MOBILE_PHONE_TIPS:
    "Only 10 digit phone numbers starting with 09 shall be accepted.",
};
